import loadable from "@loadable/component";

// The library is around 1 MB of javascript. Let's code split it.
const LazyStvUtilsFrontend = loadable.lib(() => import("stv-utils-frontend"));

export default LazyStvUtilsFrontend;
